import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import MinhaCarteira from './Page/MinhaCarteira';
import NotifyComp from './components/Notify';
import PrivateRoute from './PrivateRoute';
import NotFound from './Page/NotFound';
import Home2 from './Page/Home2';
import { isAuthenticatedUEN } from './utils';
import PoliticaDePrivacidade from './Page/PoliticaDePrivacidade';
import TermosDeUso from './Page/Termodeuso';
import Certificado from './Page/Certificado';
import LoginUser from './Page/LoginUser';
import RegistrarUser from './Page/RegistrarUser';
import EsqueciSenha from './Page/EsqueciSenha';
import RecuperarAcesso from './Page/RecuperarAcesso';
import RedefinirSenha from './Page/RedefinirSenha';
import RecuperarConta from './Page/RecuperarConta';
import ConfirmarRecuperarConta from './Page/RecuperarConta/Confirmar';
import ConfirmarEmail from './Page/ConfirmarEmail';
import DescadastrarEmail from './Page/DescadastrarEmail';
import MinhaCarteirinha from './Page/MinhaCarteirinha';
import SidebarLayout from './components/SidebarLayout';
import HistoricoPagamentos from './Page/HistoricoPagamentos';
import Produtos from './Page/Produtos';
import Dashboard from './Page/Dashboard';
import Rastreamento from './Page/Rastreamento';
import ValidarAcesso from './Page/ValidarAcesso';

function HomeOrDashboard() {
  return isAuthenticatedUEN() ? <Navigate to="/dashboard" replace /> : <Home2 />;
}

const router = createBrowserRouter([
  {
    // Logado -> dashboard; deslogado -> landing público (Home2).
    path: "/",
    element: <HomeOrDashboard />,
    errorElement: <NotFound />
  },
  {
    path: "/login",
    element: <LoginUser />,
    errorElement: <NotFound />
  },  
  {
    path: "/registrar",
    element: <RegistrarUser />,
    errorElement: <NotFound />
  },
  {
    // Tela seletora: escolhe entre recuperar SENHA ou recuperar CONTA.
    path: "/recuperar-acesso",
    element: <RecuperarAcesso />,
    errorElement: <NotFound />
  },
  {
    path: "/esqueci-senha",
    element: <EsqueciSenha />,
    errorElement: <NotFound />
  },
  {
    path: "/redefinir-senha",
    element: <RedefinirSenha />,
    errorElement: <NotFound />
  },
  {
    // Aluno antigo sem email — informa CPF+data+código de uso e escolhe
    // email + senha; backend manda confirmação pra esse email.
    path: "/recuperar-conta",
    element: <RecuperarConta />,
    errorElement: <NotFound />
  },
  {
    // Link do email cai aqui — aplica as mudanças via token.
    path: "/recuperar-conta/confirmar",
    element: <ConfirmarRecuperarConta />,
    errorElement: <NotFound />
  },
  {
    path: "/confirmar-email",
    element: <ConfirmarEmail />,
    errorElement: <NotFound />
  },
  {
    path: "/descadastrar-email",
    element: <DescadastrarEmail />,
    errorElement: <NotFound />
  },
  {
    path: "/dashboard",
    element: <PrivateRoute element={<SidebarLayout><Dashboard /></SidebarLayout>} />,
    errorElement: <NotFound />
  },
  {
    path: "/minhacarteirinha",
    element: <PrivateRoute element={<SidebarLayout><MinhaCarteirinha /></SidebarLayout>} />,
    errorElement: <NotFound />
  },
  {
    path: "/meuhistorico",
    element: <PrivateRoute element={<SidebarLayout><HistoricoPagamentos /></SidebarLayout>} />,
    errorElement: <NotFound />
  },
  {
    path: "/produtos",
    element: <PrivateRoute element={<SidebarLayout><Produtos /></SidebarLayout>} />,
    errorElement: <NotFound />
  },
  {
    path: "/rastreamento",
    element: <PrivateRoute element={<SidebarLayout><Rastreamento /></SidebarLayout>} />,
    errorElement: <NotFound />
  },
  {
    path: "/carteiraVisualizar",
    element: <PrivateRoute acess={['ESTUDANTE']} element={<MinhaCarteira />} /> ,
    errorElement: <NotFound />
  },    
  {
    // Porta pública: código de uso + data de nascimento + checagem humana → /validar/:cpf
    path: "/validacao",
    element: <ValidarAcesso />,
    errorElement: <NotFound />
  },
  {
    path: "/validar/:cpf",
    element: <Certificado/>,
    errorElement: <NotFound />
  },
  {
    path: "/certificado/:cpf",
    element: <Certificado />,
    errorElement: <NotFound />
  },  
  {
    path: "/politicadeprivacidade",
    element: <PoliticaDePrivacidade />,
    errorElement: <NotFound />
  },  
  {
    path: "/termosdeuso",
    element: <TermosDeUso />,
    errorElement: <NotFound />
  },  
  
]);
/* ADMINISTRADOR, FUNCIONARIO, ESTUDANTE */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NotifyComp />
    <RouterProvider router={router} />
  </React.StrictMode>
);
 
